<template>
  <div class="books_skleton">
    <BookSkeleton
      v-for="(book, index) in number" :key="index"
    />
  </div>
</template>

<script>
import BookSkeleton from '@/components/skeleton/Book'

export default {
  name: 'Books_Skleton',
  components: {
    BookSkeleton
  },
  props: {
    number: {
      type: Number,
      default: 6
    }
  }
}
</script>

<style lang="scss" scoped>
.books_skleton {
  display: grid;
  grid-template-columns: repeat(6, 207px);
  grid-gap: 9px;
}
</style>
